// src/models/auth.ts
var AuthProvider = /* @__PURE__ */ ((AuthProvider2) => {
  AuthProvider2["None"] = "NONE";
  AuthProvider2["Local"] = "LOCAL";
  AuthProvider2["Google"] = "GOOGLE";
  return AuthProvider2;
})(AuthProvider || {});

// src/models/discovery.dto.ts
var DiscoverySectionKey = /* @__PURE__ */ ((DiscoverySectionKey2) => {
  DiscoverySectionKey2["FEATURED"] = "FEATURED";
  DiscoverySectionKey2["TRENDING"] = "TRENDING";
  DiscoverySectionKey2["TOP_RATED"] = "TOP_RATED";
  DiscoverySectionKey2["MOST_PLAYED"] = "MOST_PLAYED";
  DiscoverySectionKey2["NEW_AND_NOTEWORTHY"] = "NEW_AND_NOTEWORTHY";
  DiscoverySectionKey2["CATEGORY_SPOTLIGHT"] = "CATEGORY_SPOTLIGHT";
  return DiscoverySectionKey2;
})(DiscoverySectionKey || {});

// src/models/authority.enum.ts
var Authority = /* @__PURE__ */ ((Authority2) => {
  Authority2["Discovery"] = "DISCOVERY";
  Authority2["Game"] = "GAME";
  Authority2["Media"] = "MEDIA";
  Authority2["Quiz"] = "QUIZ";
  Authority2["RefreshAuth"] = "REFRESH_AUTH";
  Authority2["ResetPassword"] = "RESET_PASSWORD";
  Authority2["User"] = "USER";
  Authority2["VerifyEmail"] = "VERIFY_EMAIL";
  return Authority2;
})(Authority || {});

// src/models/game-event-type.enum.ts
var GameEventType = /* @__PURE__ */ ((GameEventType2) => {
  GameEventType2["GameHeartbeat"] = "GAME_HEARTBEAT";
  GameEventType2["GameLoading"] = "GAME_LOADING";
  GameEventType2["GameLobbyHost"] = "GAME_LOBBY_HOST";
  GameEventType2["GameLobbyPlayer"] = "GAME_LOBBY_PLAYER";
  GameEventType2["GameBeginHost"] = "GAME_BEGIN_HOST";
  GameEventType2["GameBeginPlayer"] = "GAME_BEGIN_PLAYER";
  GameEventType2["GameQuestionPreviewHost"] = "GAME_QUESTION_PREVIEW_HOST";
  GameEventType2["GameQuestionPreviewPlayer"] = "GAME_QUESTION_PREVIEW_PLAYER";
  GameEventType2["GameQuestionHost"] = "GAME_QUESTION_HOST";
  GameEventType2["GameQuestionPlayer"] = "GAME_QUESTION_PLAYER";
  GameEventType2["GameLeaderboardHost"] = "GAME_LEADERBOARD_HOST";
  GameEventType2["GameResultHost"] = "GAME_RESULT_HOST";
  GameEventType2["GameResultPlayer"] = "GAME_RESULT_PLAYER";
  GameEventType2["GamePodiumHost"] = "GAME_PODIUM_HOST";
  GameEventType2["GameOverPlayer"] = "GAME_OVER_PLAYER";
  GameEventType2["GameQuitEvent"] = "GAME_QUIT_EVENT";
  return GameEventType2;
})(GameEventType || {});

// src/models/game-mode.enum.ts
var GameMode = /* @__PURE__ */ ((GameMode2) => {
  GameMode2["Classic"] = "CLASSIC";
  GameMode2["ZeroToOneHundred"] = "ZERO_TO_ONE_HUNDRED";
  return GameMode2;
})(GameMode || {});

// src/models/game-participant-type.enum.ts
var GameParticipantType = /* @__PURE__ */ ((GameParticipantType2) => {
  GameParticipantType2["HOST"] = "HOST";
  GameParticipantType2["PLAYER"] = "PLAYER";
  return GameParticipantType2;
})(GameParticipantType || {});

// src/models/game-status.enum.ts
var GameStatus = /* @__PURE__ */ ((GameStatus2) => {
  GameStatus2["Active"] = "ACTIVE";
  GameStatus2["Completed"] = "COMPLETED";
  GameStatus2["Expired"] = "EXPIRED";
  GameStatus2["Terminated"] = "TERMINATED";
  return GameStatus2;
})(GameStatus || {});

// src/models/language-code.enum.ts
var LanguageCode = /* @__PURE__ */ ((LanguageCode2) => {
  LanguageCode2["Abkhaz"] = "ab";
  LanguageCode2["Afar"] = "aa";
  LanguageCode2["Afrikaans"] = "af";
  LanguageCode2["Akan"] = "ak";
  LanguageCode2["Albanian"] = "sq";
  LanguageCode2["Amharic"] = "am";
  LanguageCode2["Arabic"] = "ar";
  LanguageCode2["Aragonese"] = "an";
  LanguageCode2["Armenian"] = "hy";
  LanguageCode2["Assamese"] = "as";
  LanguageCode2["Avaric"] = "av";
  LanguageCode2["Avestan"] = "ae";
  LanguageCode2["Aymara"] = "ay";
  LanguageCode2["Azerbaijani"] = "az";
  LanguageCode2["Bambara"] = "bm";
  LanguageCode2["Bashkir"] = "ba";
  LanguageCode2["Basque"] = "eu";
  LanguageCode2["Belarusian"] = "be";
  LanguageCode2["Bengali"] = "bn";
  LanguageCode2["Bihari"] = "bh";
  LanguageCode2["Bislama"] = "bi";
  LanguageCode2["Bosnian"] = "bs";
  LanguageCode2["Breton"] = "br";
  LanguageCode2["Bulgarian"] = "bg";
  LanguageCode2["Burmese"] = "my";
  LanguageCode2["Catalan"] = "ca";
  LanguageCode2["Chamorro"] = "ch";
  LanguageCode2["Chechen"] = "ce";
  LanguageCode2["Chichewa"] = "ny";
  LanguageCode2["Chinese"] = "zh";
  LanguageCode2["ChurchSlavonic"] = "cu";
  LanguageCode2["Chuvash"] = "cv";
  LanguageCode2["Cornish"] = "kw";
  LanguageCode2["Corsican"] = "co";
  LanguageCode2["Cree"] = "cr";
  LanguageCode2["Croatian"] = "hr";
  LanguageCode2["Czech"] = "cs";
  LanguageCode2["Danish"] = "da";
  LanguageCode2["Dhivehi"] = "dv";
  LanguageCode2["Dutch"] = "nl";
  LanguageCode2["Dzongkha"] = "dz";
  LanguageCode2["English"] = "en";
  LanguageCode2["Esperanto"] = "eo";
  LanguageCode2["Estonian"] = "et";
  LanguageCode2["Ewe"] = "ee";
  LanguageCode2["Faroese"] = "fo";
  LanguageCode2["Fijian"] = "fj";
  LanguageCode2["Finnish"] = "fi";
  LanguageCode2["French"] = "fr";
  LanguageCode2["Fula"] = "ff";
  LanguageCode2["Galician"] = "gl";
  LanguageCode2["Ganda"] = "lg";
  LanguageCode2["Georgian"] = "ka";
  LanguageCode2["German"] = "de";
  LanguageCode2["Greek"] = "el";
  LanguageCode2["Guarani"] = "gn";
  LanguageCode2["Gujarati"] = "gu";
  LanguageCode2["Haitian"] = "ht";
  LanguageCode2["Hausa"] = "ha";
  LanguageCode2["Hebrew"] = "he";
  LanguageCode2["Herero"] = "hz";
  LanguageCode2["Hindi"] = "hi";
  LanguageCode2["HiriMotu"] = "ho";
  LanguageCode2["Hungarian"] = "hu";
  LanguageCode2["Icelandic"] = "is";
  LanguageCode2["Ido"] = "io";
  LanguageCode2["Igbo"] = "ig";
  LanguageCode2["Indonesian"] = "id";
  LanguageCode2["Interlingua"] = "ia";
  LanguageCode2["Interlingue"] = "ie";
  LanguageCode2["Inuktitut"] = "iu";
  LanguageCode2["Inupiaq"] = "ik";
  LanguageCode2["Irish"] = "ga";
  LanguageCode2["Italian"] = "it";
  LanguageCode2["Japanese"] = "ja";
  LanguageCode2["Javanese"] = "jv";
  LanguageCode2["Kalaallisut"] = "kl";
  LanguageCode2["Kannada"] = "kn";
  LanguageCode2["Kanuri"] = "kr";
  LanguageCode2["Kashmiri"] = "ks";
  LanguageCode2["Kazakh"] = "kk";
  LanguageCode2["Khmer"] = "km";
  LanguageCode2["Kikuyu"] = "ki";
  LanguageCode2["Kinyarwanda"] = "rw";
  LanguageCode2["Kirundi"] = "rn";
  LanguageCode2["Komi"] = "kv";
  LanguageCode2["Kongo"] = "kg";
  LanguageCode2["Korean"] = "ko";
  LanguageCode2["Kurdish"] = "ku";
  LanguageCode2["Kwanyama"] = "kj";
  LanguageCode2["Kyrgyz"] = "ky";
  LanguageCode2["Lao"] = "lo";
  LanguageCode2["Latin"] = "la";
  LanguageCode2["Latvian"] = "lv";
  LanguageCode2["Limburgish"] = "li";
  LanguageCode2["Lingala"] = "ln";
  LanguageCode2["Lithuanian"] = "lt";
  LanguageCode2["LubaKatanga"] = "lu";
  LanguageCode2["Luxembourgish"] = "lb";
  LanguageCode2["Macedonian"] = "mk";
  LanguageCode2["Malagasy"] = "mg";
  LanguageCode2["Malay"] = "ms";
  LanguageCode2["Malayalam"] = "ml";
  LanguageCode2["Maltese"] = "mt";
  LanguageCode2["Manx"] = "gv";
  LanguageCode2["Marathi"] = "mr";
  LanguageCode2["Marshallese"] = "mh";
  LanguageCode2["Mongolian"] = "mn";
  LanguageCode2["Maori"] = "mi";
  LanguageCode2["Nauru"] = "na";
  LanguageCode2["Navajo"] = "nv";
  LanguageCode2["Ndonga"] = "ng";
  LanguageCode2["Nepali"] = "ne";
  LanguageCode2["NorthernNdebele"] = "nd";
  LanguageCode2["NorthernSami"] = "se";
  LanguageCode2["NorwegianBokmal"] = "nb";
  LanguageCode2["NorwegianNynorsk"] = "nn";
  LanguageCode2["Nuosu"] = "ii";
  LanguageCode2["Occitan"] = "oc";
  LanguageCode2["Ojibwe"] = "oj";
  LanguageCode2["Oriya"] = "or";
  LanguageCode2["Oromo"] = "om";
  LanguageCode2["Ossetian"] = "os";
  LanguageCode2["Pashto"] = "ps";
  LanguageCode2["Persian"] = "fa";
  LanguageCode2["Polish"] = "pl";
  LanguageCode2["Portuguese"] = "pt";
  LanguageCode2["Punjabi"] = "pa";
  LanguageCode2["Pali"] = "pi";
  LanguageCode2["Quechua"] = "qu";
  LanguageCode2["Romanian"] = "ro";
  LanguageCode2["Romansh"] = "rm";
  LanguageCode2["Russian"] = "ru";
  LanguageCode2["Samoan"] = "sm";
  LanguageCode2["Sango"] = "sg";
  LanguageCode2["Sanskrit"] = "sa";
  LanguageCode2["Sardinian"] = "sc";
  LanguageCode2["ScottishGaelic"] = "gd";
  LanguageCode2["Serbian"] = "sr";
  LanguageCode2["Shona"] = "sn";
  LanguageCode2["Sindhi"] = "sd";
  LanguageCode2["Sinhala"] = "si";
  LanguageCode2["Slovak"] = "sk";
  LanguageCode2["Slovene"] = "sl";
  LanguageCode2["Somali"] = "so";
  LanguageCode2["SouthernNdebele"] = "nr";
  LanguageCode2["SouthernSotho"] = "st";
  LanguageCode2["Spanish"] = "es";
  LanguageCode2["Sundanese"] = "su";
  LanguageCode2["Swahili"] = "sw";
  LanguageCode2["Swati"] = "ss";
  LanguageCode2["Swedish"] = "sv";
  LanguageCode2["Tagalog"] = "tl";
  LanguageCode2["Tahitian"] = "ty";
  LanguageCode2["Tajik"] = "tg";
  LanguageCode2["Tamil"] = "ta";
  LanguageCode2["Tatar"] = "tt";
  LanguageCode2["Telugu"] = "te";
  LanguageCode2["Thai"] = "th";
  LanguageCode2["Tibetan"] = "bo";
  LanguageCode2["Tigrinya"] = "ti";
  LanguageCode2["Tongan"] = "to";
  LanguageCode2["Tsonga"] = "ts";
  LanguageCode2["Tswana"] = "tn";
  LanguageCode2["Turkish"] = "tr";
  LanguageCode2["Turkmen"] = "tk";
  LanguageCode2["Twi"] = "tw";
  LanguageCode2["Uighur"] = "ug";
  LanguageCode2["Ukrainian"] = "uk";
  LanguageCode2["Urdu"] = "ur";
  LanguageCode2["Uzbek"] = "uz";
  LanguageCode2["Venda"] = "ve";
  LanguageCode2["Vietnamese"] = "vi";
  LanguageCode2["Volapuk"] = "vo";
  LanguageCode2["Walloon"] = "wa";
  LanguageCode2["Welsh"] = "cy";
  LanguageCode2["WestFrisian"] = "fy";
  LanguageCode2["Wolof"] = "wo";
  LanguageCode2["Xhosa"] = "xh";
  LanguageCode2["Yiddish"] = "yi";
  LanguageCode2["Yoruba"] = "yo";
  LanguageCode2["Zhuang"] = "za";
  LanguageCode2["Zulu"] = "zu";
  return LanguageCode2;
})(LanguageCode || {});

// src/models/media-type.enum.ts
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["Image"] = "IMAGE";
  MediaType2["Audio"] = "AUDIO";
  MediaType2["Video"] = "VIDEO";
  return MediaType2;
})(MediaType || {});

// src/models/question-image-reveal-effect-type.enum.ts
var QuestionImageRevealEffectType = /* @__PURE__ */ ((QuestionImageRevealEffectType2) => {
  QuestionImageRevealEffectType2["Blur"] = "BLUR";
  QuestionImageRevealEffectType2["Square3x3"] = "SQUARE_3X3";
  QuestionImageRevealEffectType2["Square5x5"] = "SQUARE_5X5";
  QuestionImageRevealEffectType2["Square8x8"] = "SQUARE_8X8";
  return QuestionImageRevealEffectType2;
})(QuestionImageRevealEffectType || {});

// src/models/question-pin-tolerance.enum.ts
var QuestionPinTolerance = /* @__PURE__ */ ((QuestionPinTolerance2) => {
  QuestionPinTolerance2["Maximum"] = "MAXIMUM";
  QuestionPinTolerance2["High"] = "HIGH";
  QuestionPinTolerance2["Medium"] = "MEDIUM";
  QuestionPinTolerance2["Low"] = "LOW";
  return QuestionPinTolerance2;
})(QuestionPinTolerance || {});

// src/models/question-range-answer-margin.enum.ts
var QuestionRangeAnswerMargin = /* @__PURE__ */ ((QuestionRangeAnswerMargin2) => {
  QuestionRangeAnswerMargin2["None"] = "NONE";
  QuestionRangeAnswerMargin2["Low"] = "LOW";
  QuestionRangeAnswerMargin2["Medium"] = "MEDIUM";
  QuestionRangeAnswerMargin2["High"] = "HIGH";
  QuestionRangeAnswerMargin2["Maximum"] = "MAXIMUM";
  return QuestionRangeAnswerMargin2;
})(QuestionRangeAnswerMargin || {});

// src/models/question-type.enum.ts
var QuestionType = /* @__PURE__ */ ((QuestionType2) => {
  QuestionType2["MultiChoice"] = "MULTI_CHOICE";
  QuestionType2["Range"] = "RANGE";
  QuestionType2["TrueFalse"] = "TRUE_FALSE";
  QuestionType2["TypeAnswer"] = "TYPE_ANSWER";
  QuestionType2["Pin"] = "PIN";
  QuestionType2["Puzzle"] = "PUZZLE";
  return QuestionType2;
})(QuestionType || {});

// src/models/quiz.dto.ts
var QuizVisibility = /* @__PURE__ */ ((QuizVisibility2) => {
  QuizVisibility2["Public"] = "PUBLIC";
  QuizVisibility2["Private"] = "PRIVATE";
  return QuizVisibility2;
})(QuizVisibility || {});
var QuizCategory = /* @__PURE__ */ ((QuizCategory2) => {
  QuizCategory2["GeneralKnowledge"] = "GENERAL_KNOWLEDGE";
  QuizCategory2["Science"] = "SCIENCE";
  QuizCategory2["History"] = "HISTORY";
  QuizCategory2["Geography"] = "GEOGRAPHY";
  QuizCategory2["Entertainment"] = "ENTERTAINMENT";
  QuizCategory2["Sports"] = "SPORTS";
  QuizCategory2["Literature"] = "LITERATURE";
  QuizCategory2["Technology"] = "TECHNOLOGY";
  QuizCategory2["Art"] = "ART";
  QuizCategory2["Music"] = "MUSIC";
  QuizCategory2["Film"] = "FILM";
  QuizCategory2["FoodAndDrink"] = "FOOD_AND_DRINK";
  QuizCategory2["Politics"] = "POLITICS";
  QuizCategory2["Mythology"] = "MYTHOLOGY";
  QuizCategory2["Nature"] = "NATURE";
  QuizCategory2["Business"] = "BUSINESS";
  QuizCategory2["Health"] = "HEALTH";
  QuizCategory2["Religion"] = "RELIGION";
  QuizCategory2["Space"] = "SPACE";
  QuizCategory2["Mathematics"] = "MATHEMATICS";
  QuizCategory2["Other"] = "OTHER";
  return QuizCategory2;
})(QuizCategory || {});

// src/models/quiz-rating-author-type.enum.ts
var QuizRatingAuthorType = /* @__PURE__ */ ((QuizRatingAuthorType2) => {
  QuizRatingAuthorType2["User"] = "USER";
  QuizRatingAuthorType2["Anonymous"] = "ANONYMOUS";
  return QuizRatingAuthorType2;
})(QuizRatingAuthorType || {});

// src/models/token.dto.ts
var TokenType = /* @__PURE__ */ ((TokenType2) => {
  TokenType2["Access"] = "ACCESS";
  TokenType2["Refresh"] = "REFRESH";
  TokenType2["PasswordReset"] = "PASSWORD_RESET";
  return TokenType2;
})(TokenType || {});
var TokenScope = /* @__PURE__ */ ((TokenScope2) => {
  TokenScope2["Game"] = "GAME";
  TokenScope2["User"] = "USER";
  return TokenScope2;
})(TokenScope || {});

// src/utils/array.utils.ts
function arraysEqual(a, b) {
  if (!a || !b || a.length !== b.length) return false;
  return a.every((val, i) => val === b[i]);
}
function shuffleArray(arr) {
  if (arr.length <= 1) return arr;
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
function shuffleDifferent(arr) {
  if (arr.length <= 1) return arr;
  const hasDistinctPermutation = new Set(arr).size > 1;
  let shuffled;
  do {
    shuffled = shuffleArray(arr);
  } while (hasDistinctPermutation && arraysEqual(shuffled, arr));
  return shuffled;
}

// src/utils/constants.ts
var HEARTBEAT_INTERVAL = 15e3;
var EMOJI_RANGE = "\\u{1F300}-\\u{1F5FF}\\u{1F900}-\\u{1F9FF}\\u{1F600}-\\u{1F64F}\\u{1F680}-\\u{1F6FF}\\u{2600}-\\u{26FF}\\u{2700}-\\u{27BF}\\u{1F1E6}-\\u{1F1FF}\\u{1F191}-\\u{1F251}\\u{1F004}\\u{1F0CF}\\u{1F170}-\\u{1F171}\\u{1F17E}-\\u{1F17F}\\u{1F18E}\\u{3030}\\u{2B50}\\u{2B55}\\u{2934}-\\u{2935}\\u{2B05}-\\u{2B07}\\u{2B1B}-\\u{2B1C}\\u{3297}\\u{3299}\\u{303D}\\u{00A9}\\u{00AE}\\u{2122}\\u{23F3}\\u{24C2}\\u{23E9}-\\u{23EF}\\u{25B6}\\u{23F8}-\\u{23FA}";
var QUIZ_TITLE_MIN_LENGTH = 3;
var QUIZ_TITLE_MAX_LENGTH = 95;
var QUIZ_TITLE_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{3,95}$`,
  "u"
);
var QUIZ_DESCRIPTION_MAX_LENGTH = 500;
var QUIZ_DESCRIPTION_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}\\n\\r]{1,500}$`,
  "u"
);
var GAME_PIN_REGEX = /^[1-9]\d{5}$/;
var GAME_PIN_LENGTH = 6;
var GAME_MIN_PLAYERS = 0;
var GAME_MAX_PLAYERS = 20;
var PLAYER_NICKNAME_MIN_LENGTH = 2;
var PLAYER_NICKNAME_MAX_LENGTH = 20;
var PLAYER_NICKNAME_REGEX = new RegExp(
  `^[\\p{L}\\p{N}_${EMOJI_RANGE}]{2,20}$`,
  "u"
);
var URL_REGEX = /^(https?:\/\/)(localhost|(\d{1,3}\.){3}\d{1,3}|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/;
var QUIZ_QUESTION_MIN = 1;
var QUIZ_QUESTION_MAX = 50;
var QUIZ_QUESTION_TEXT_MIN_LENGTH = 3;
var QUIZ_QUESTION_TEXT_MAX_LENGTH = 120;
var QUIZ_QUESTION_TEXT_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{3,120}$`,
  "u"
);
var QUIZ_QUESTION_INFO_MIN_LENGTH = 1;
var QUIZ_QUESTION_INFO_MAX_LENGTH = 256;
var QUIZ_QUESTION_INFO_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{1,256}$`,
  "u"
);
var QUIZ_MULTI_CHOICE_OPTIONS_MIN = 2;
var QUIZ_MULTI_CHOICE_OPTIONS_MAX = 6;
var QUIZ_MULTI_CHOICE_OPTION_VALUE_MIN_LENGTH = 1;
var QUIZ_MULTI_CHOICE_OPTION_VALUE_MAX_LENGTH = 75;
var QUIZ_MULTI_CHOICE_OPTION_VALUE_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{1,75}$`,
  "u"
);
var QUIZ_RANGE_MIN_VALUE = -999999999;
var QUIZ_RANGE_MAX_VALUE = 999999999;
var QUIZ_TYPE_ANSWER_OPTIONS_MIN = 1;
var QUIZ_TYPE_ANSWER_OPTIONS_MAX = 4;
var QUIZ_TYPE_ANSWER_OPTIONS_VALUE_MIN_LENGTH = 1;
var QUIZ_TYPE_ANSWER_OPTIONS_VALUE_MAX_LENGTH = 20;
var QUIZ_TYPE_ANSWER_OPTIONS_VALUE_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{1,75}$`,
  "u"
);
var QUESTION_PIN_TOLERANCE_RADIUS = {
  MAXIMUM: 1,
  HIGH: 0.2,
  MEDIUM: 0.12,
  LOW: 0.06
};
var QUIZ_PUZZLE_VALUES_MIN = 3;
var QUIZ_PUZZLE_VALUES_MAX = 6;
var QUIZ_PUZZLE_VALUE_MIN_LENGTH = 1;
var QUIZ_PUZZLE_VALUE_MAX_LENGTH = 75;
var QUIZ_PUZZLE_VALUE_REGEX = new RegExp(
  `^[\\p{L}\\p{N}\\p{P}\\p{S}\\p{Zs}${EMOJI_RANGE}]{1,75}$`,
  "u"
);
var ZERO_TO_ONE_HUNDRED_MIN_ANSWER = 0;
var ZERO_TO_ONE_HUNDRED_MAX_ANSWER = 100;
var ZERO_TO_ONE_HUNDRED_BONUS_POINTS = -10;
var ZERO_TO_ONE_HUNDRED_PENALTY_POINTS = ZERO_TO_ONE_HUNDRED_MAX_ANSWER;
var QUIZ_ZERO_POINTS = 0;
var QUIZ_STANDARD_POINTS = 1e3;
var QUIZ_DOUBLE_POINTS = 2e3;
var QUIZ_MIN_POINTS = QUIZ_ZERO_POINTS;
var QUIZ_MAX_POINTS = QUIZ_DOUBLE_POINTS;
var QUIZ_POINTS_ALLOWED = [
  QUIZ_ZERO_POINTS,
  QUIZ_STANDARD_POINTS,
  QUIZ_DOUBLE_POINTS
];
var QUIZ_DURATION_ALLOWED = [
  5,
  10,
  20,
  30,
  45,
  60,
  90,
  120,
  180,
  240
];
var QUIZ_RATING_STARS_MIN = 1;
var QUIZ_RATING_STARS_MAX = 5;
var QUIZ_RATING_COMMENT_MIN_LENGTH = 1;
var QUIZ_RATING_COMMENT_MAX_LENGTH = 255;
var QUIZ_RATING_COMMENT_REGEX = /^(?!\s*$).+/;
var PLAYER_LINK_CODE_REGEX = /^[A-Z0-9]{4}-[A-Z0-9]{4}$/;
var DEFAULT_QUIZ_PAGINATION_LIMIT = 5;
var MEDIA_SEARCH_TERM_MIN_LENGTH = 2;
var MEDIA_SEARCH_TERM_MAX_LENGTH = 20;
var MEDIA_SEARCH_TERM_REGEX = /^[a-zA-Z0-9_ ]{2,20}$/;
var UPLOAD_IMAGE_MIN_FILE_SIZE = 1;
var UPLOAD_IMAGE_MAX_FILE_SIZE = 20 * 1024 * 1024;
var UPLOAD_IMAGE_MIMETYPE_REGEX = /^image\/(gif|jpeg|png|tiff|webp)$/;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 128;
var PASSWORD_REGEX = /^(?=(?:.*[a-z]){2,})(?=(?:.*[A-Z]){2,})(?=(?:.*\d){2,})(?=(?:.*[^A-Za-z0-9]){2,}).{8,128}$/;
var EMAIL_MIN_LENGTH = 6;
var EMAIL_MAX_LENGTH = 128;
var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var GIVEN_NAME_MIN_LENGTH = 1;
var GIVEN_NAME_MAX_LENGTH = 64;
var GIVEN_NAME_REGEX = /^(?=.{1,64}$)[\p{L}\p{M}]+(?:[ '-][\p{L}\p{M}]+)*$/u;
var FAMILY_NAME_MIN_LENGTH = 1;
var FAMILY_NAME_MAX_LENGTH = 64;
var FAMILY_NAME_REGEX = /^(?=.{1,64}$)[\p{L}\p{M}]+(?:[ '-][\p{L}\p{M}]+)*$/u;
var GOOGLE_OAUTH_CODE_REGEX = /^[0-9A-Za-z\-_/+=]{10,512}$/;
var GOOGLE_OAUTH_CODE_VERIFIER_REGEX = /^[A-Za-z0-9\-._~]{43,128}$/;

// src/utils/nickname.utils.ts
var generateNickname = () => {
  const adjectives = [
    "Frosty",
    "Fiery",
    "Electric",
    "Shadow",
    "Mystic",
    "Thunder",
    "Icy",
    "Swift",
    "Crimson",
    "Golden",
    "Stormy",
    "Lunar",
    "Solar",
    "Phantom",
    "Radiant",
    "Infernal",
    "Celestial",
    "Vivid",
    "Rogue",
    "Twisted",
    "Majestic",
    "Cosmic",
    "Glacial",
    "Wild",
    "Brave",
    "Turbo",
    "Velvet",
    "Atomic",
    "Echo",
    "Daring"
  ];
  const animals = [
    "Bear",
    "Wolf",
    "Fox",
    "Falcon",
    "Dragon",
    "Tiger",
    "Panther",
    "Phoenix",
    "Eagle",
    "Serpent",
    "Raven",
    "Shark",
    "Lynx",
    "Cheetah",
    "Cobra",
    "Bison",
    "Jackal",
    "Owl",
    "Leopard",
    "Puma",
    "Viper",
    "Stallion",
    "Kraken",
    "Hawk",
    "Tundra",
    "Raptor",
    "Basilisk",
    "Griffin",
    "Scorpion",
    "Yeti"
  ];
  const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
  return `${getRandomElement(adjectives)}${getRandomElement(animals)}`;
};

// src/utils/object.utils.ts
import equal from "fast-deep-equal";
var deepEqual = (a, b) => {
  return equal(a, b);
};

// src/utils/question-preview-duration.utils.ts
var AVERAGE_READING_SPEED_WORDS_PER_MINUTE = 220;
var MILLISECONDS_PER_MINUTE = 6e4;
var MILLISECONDS_PER_CHARACTER = 100;
var MAX_CHARACTER_DURATION_MS = 15e3;
var getQuestionPreviewDurationMs = (questionText) => {
  const wordCount = questionText.trim().split(/\s+/).length;
  const readingDurationMs = wordCount / AVERAGE_READING_SPEED_WORDS_PER_MINUTE * MILLISECONDS_PER_MINUTE;
  const characterDurationMs = Math.min(
    questionText.length * MILLISECONDS_PER_CHARACTER,
    MAX_CHARACTER_DURATION_MS
  );
  return Math.max(readingDurationMs, characterDurationMs);
};

// src/utils/range.utils.ts
function calculateRangeBounds(margin, correct, min, max, step) {
  if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) {
    throw new Error("Invalid min/max");
  }
  const s = Number(step) > 0 ? Number(step) : max - min || 1;
  const range = max - min;
  if (margin === "MAXIMUM" /* Maximum */) {
    return { lower: min, upper: max };
  }
  if (margin === "NONE" /* None */ || range === 0) {
    const gridValue = snapToStepInside(correct, min, max, s);
    return { lower: gridValue, upper: gridValue };
  }
  const pct = {
    ["LOW" /* Low */]: 0.05,
    ["MEDIUM" /* Medium */]: 0.1,
    ["HIGH" /* High */]: 0.2
  }[margin];
  const halfWidth = range * pct;
  const rawLower = correct - halfWidth;
  const rawUpper = correct + halfWidth;
  const lower = clamp(floorToStep(rawLower, min, s), min, max);
  const upper = clamp(ceilToStep(rawUpper, min, s), min, max);
  return ensureAtLeastOneStep({ lower, upper }, min, max, s);
}
function calculateRangeStep(min, max, targetSteps = 50) {
  const range = max - min;
  if (range <= 0) {
    return 0;
  }
  const rawStep = range / targetSteps;
  const minimumStep = 1;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const refinedStep = rawStep <= magnitude ? magnitude : Math.ceil(rawStep / magnitude) * magnitude;
  return Math.max(refinedStep, minimumStep);
}
function clamp(x, a, b) {
  return Math.max(a, Math.min(b, x));
}
function floorToStep(x, min, step) {
  return Math.floor((x - min) / step) * step + min;
}
function ceilToStep(x, min, step) {
  return Math.ceil((x - min) / step) * step + min;
}
function snapToStep(x, min, step) {
  return Math.round((x - min) / step) * step + min;
}
function ensureAtLeastOneStep(b, min, max, step) {
  if (b.upper - b.lower >= step) return b;
  if (b.upper + step <= max) return { lower: b.lower, upper: b.upper + step };
  if (b.lower - step >= min) return { lower: b.lower - step, upper: b.upper };
  return { lower: min, upper: max };
}
function snapToStepInside(x, min, max, step) {
  if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) {
    return clamp(x, min, max);
  }
  const s = Number(step);
  if (!(s > 0)) return clamp(x, min, max);
  const span = max - min;
  const N = Math.floor(span / s);
  const gridAt = (n) => min + n * s;
  if (N <= 0) {
    return min;
  }
  const nFloat = (x - min) / s;
  const nDown = Math.floor(nFloat);
  const nUp = nDown + 1;
  const candidates = [];
  if (nDown >= 0 && nDown <= N) candidates.push(gridAt(nDown));
  if (nUp >= 0 && nUp <= N && nUp !== nDown) candidates.push(gridAt(nUp));
  if (candidates.length === 0) {
    const minGrid = gridAt(0);
    const maxGrid = gridAt(N);
    return Math.abs(x - minGrid) <= Math.abs(x - maxGrid) ? minGrid : maxGrid;
  }
  if (candidates.length === 1) return candidates[0];
  const [a, b] = candidates;
  const da = Math.abs(a - x);
  const db = Math.abs(b - x);
  if (da === db) return Math.min(a, b);
  return da < db ? a : b;
}

// src/utils/string.utils.ts
function normalizeString(input) {
  return (input ?? "").trim().toLowerCase();
}

// src/utils/type-guards.utils.ts
function isDefined(value) {
  return value !== void 0 && value !== null;
}
export {
  AuthProvider,
  Authority,
  DEFAULT_QUIZ_PAGINATION_LIMIT,
  DiscoverySectionKey,
  EMAIL_MAX_LENGTH,
  EMAIL_MIN_LENGTH,
  EMAIL_REGEX,
  FAMILY_NAME_MAX_LENGTH,
  FAMILY_NAME_MIN_LENGTH,
  FAMILY_NAME_REGEX,
  GAME_MAX_PLAYERS,
  GAME_MIN_PLAYERS,
  GAME_PIN_LENGTH,
  GAME_PIN_REGEX,
  GIVEN_NAME_MAX_LENGTH,
  GIVEN_NAME_MIN_LENGTH,
  GIVEN_NAME_REGEX,
  GOOGLE_OAUTH_CODE_REGEX,
  GOOGLE_OAUTH_CODE_VERIFIER_REGEX,
  GameEventType,
  GameMode,
  GameParticipantType,
  GameStatus,
  HEARTBEAT_INTERVAL,
  LanguageCode,
  MEDIA_SEARCH_TERM_MAX_LENGTH,
  MEDIA_SEARCH_TERM_MIN_LENGTH,
  MEDIA_SEARCH_TERM_REGEX,
  MediaType,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_REGEX,
  PLAYER_LINK_CODE_REGEX,
  PLAYER_NICKNAME_MAX_LENGTH,
  PLAYER_NICKNAME_MIN_LENGTH,
  PLAYER_NICKNAME_REGEX,
  QUESTION_PIN_TOLERANCE_RADIUS,
  QUIZ_DESCRIPTION_MAX_LENGTH,
  QUIZ_DESCRIPTION_REGEX,
  QUIZ_DOUBLE_POINTS,
  QUIZ_DURATION_ALLOWED,
  QUIZ_MAX_POINTS,
  QUIZ_MIN_POINTS,
  QUIZ_MULTI_CHOICE_OPTIONS_MAX,
  QUIZ_MULTI_CHOICE_OPTIONS_MIN,
  QUIZ_MULTI_CHOICE_OPTION_VALUE_MAX_LENGTH,
  QUIZ_MULTI_CHOICE_OPTION_VALUE_MIN_LENGTH,
  QUIZ_MULTI_CHOICE_OPTION_VALUE_REGEX,
  QUIZ_POINTS_ALLOWED,
  QUIZ_PUZZLE_VALUES_MAX,
  QUIZ_PUZZLE_VALUES_MIN,
  QUIZ_PUZZLE_VALUE_MAX_LENGTH,
  QUIZ_PUZZLE_VALUE_MIN_LENGTH,
  QUIZ_PUZZLE_VALUE_REGEX,
  QUIZ_QUESTION_INFO_MAX_LENGTH,
  QUIZ_QUESTION_INFO_MIN_LENGTH,
  QUIZ_QUESTION_INFO_REGEX,
  QUIZ_QUESTION_MAX,
  QUIZ_QUESTION_MIN,
  QUIZ_QUESTION_TEXT_MAX_LENGTH,
  QUIZ_QUESTION_TEXT_MIN_LENGTH,
  QUIZ_QUESTION_TEXT_REGEX,
  QUIZ_RANGE_MAX_VALUE,
  QUIZ_RANGE_MIN_VALUE,
  QUIZ_RATING_COMMENT_MAX_LENGTH,
  QUIZ_RATING_COMMENT_MIN_LENGTH,
  QUIZ_RATING_COMMENT_REGEX,
  QUIZ_RATING_STARS_MAX,
  QUIZ_RATING_STARS_MIN,
  QUIZ_STANDARD_POINTS,
  QUIZ_TITLE_MAX_LENGTH,
  QUIZ_TITLE_MIN_LENGTH,
  QUIZ_TITLE_REGEX,
  QUIZ_TYPE_ANSWER_OPTIONS_MAX,
  QUIZ_TYPE_ANSWER_OPTIONS_MIN,
  QUIZ_TYPE_ANSWER_OPTIONS_VALUE_MAX_LENGTH,
  QUIZ_TYPE_ANSWER_OPTIONS_VALUE_MIN_LENGTH,
  QUIZ_TYPE_ANSWER_OPTIONS_VALUE_REGEX,
  QUIZ_ZERO_POINTS,
  QuestionImageRevealEffectType,
  QuestionPinTolerance,
  QuestionRangeAnswerMargin,
  QuestionType,
  QuizCategory,
  QuizRatingAuthorType,
  QuizVisibility,
  TokenScope,
  TokenType,
  UPLOAD_IMAGE_MAX_FILE_SIZE,
  UPLOAD_IMAGE_MIMETYPE_REGEX,
  UPLOAD_IMAGE_MIN_FILE_SIZE,
  URL_REGEX,
  ZERO_TO_ONE_HUNDRED_BONUS_POINTS,
  ZERO_TO_ONE_HUNDRED_MAX_ANSWER,
  ZERO_TO_ONE_HUNDRED_MIN_ANSWER,
  ZERO_TO_ONE_HUNDRED_PENALTY_POINTS,
  arraysEqual,
  calculateRangeBounds,
  calculateRangeStep,
  ceilToStep,
  clamp,
  deepEqual,
  ensureAtLeastOneStep,
  floorToStep,
  generateNickname,
  getQuestionPreviewDurationMs,
  isDefined,
  normalizeString,
  shuffleArray,
  shuffleDifferent,
  snapToStep,
  snapToStepInside
};
//# sourceMappingURL=index.mjs.map